module.exports = __webpack_public_path__ + "static/media/ziggs.163b85d4.png";